module.exports = __webpack_public_path__ + "img/img75.e71dcadb.svg";